import { render, staticRenderFns } from "./NotificationContent.vue?vue&type=template&id=308b45ef&scoped=true&"
import script from "./NotificationContent.vue?vue&type=script&lang=js&"
export * from "./NotificationContent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationContent.vue?vue&type=style&index=0&id=308b45ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308b45ef",
  null
  
)

export default component.exports